import React, {useState} from 'react';
import { useDispatch } from 'react-redux';
import { addCategory } from '../../actions/AdminCategoryActions';
import ExitIcon from '../adminIcons/CrossIconInfo.svg'
import Attach from '../adminIcons/Attach.svg'
import SwitchOn from '../adminIcons/SwitchOn.svg'
import SwitchOff from '../adminIcons/SwitchOff.svg'

const AddCategory = (props) => {

    const [imageFile, setImageFile] = useState()
    const [imageURL, setImageUrl] = useState()
    const [statusOn, setStatusOn] = useState(0)

    const dispatch = useDispatch()

    const [title, setTitle] = useState('')

    const exitHandler = () => {
        setTitle('')
        props.setIsActive(false)
    }


    const handleImage = (e) => {
        setImageFile(e.target.files[0])
        let u = URL.createObjectURL(e.target.files[0])
        setImageUrl(u)
    }


    const saveHandler = () => {
        if (!title.length){
            alert('Please, Provide Title')
        } else {
            dispatch(addCategory(title, statusOn, imageFile))
            props.setIsActive(false)
        }
    }


    return (
        <div
            style={{                
                width:"1020px", 
                height:"900px"
            }}>
            <div className = 'w-100 d-flex justify-content-center'>
                <div className='w-100 bg-primary rounded p-5 d-flex flex-column admin-search-wrapper'>
                    <div className = 'd-flex justify-content-end mb-1'>
                        <img 
                            src = {ExitIcon}
                            role = 'button'
                            alt = "exit"
                            onClick={exitHandler}/>
                    </div>
                    <div className='w-100 d-flex justify-content-between align-items-center'>
                        <div className = 'px-2 text-secondary fs-8 pb-3 fw-bold'>ADD TITLE</div>
                        <div className = "px-4" role = "button">
                            {
                                statusOn === 0 ? 
                                <div className = "d-flex align-items-end">
                                    <img className='col-6' src = {SwitchOff} alt = "" onClick={()=>{setStatusOn(1)}}/>
                                    <div className = "col-6 text-info ms-4">OFF</div>
                                </div>
                                    : 
                                    <div className = "d-flex align-items-end">
                                    <img className='col-6' src = {SwitchOn} alt = "" onClick={()=>{setStatusOn(0)}}/>
                                    <div className = "col-6 text-info ms-4">ON</div>
                                </div>
                            }
                        </div>
                    </div>
 
                    <div className = "col-12 px-2 position-relative d-flex justify-content-end align-items-center" 
                        style={{userSelect:"none", height:"2.5rem"}} 
                        onClick={(e)=>e.stopPropagation()}
                        >
                        <div className="w-100 h-100 w-lg-75 col-lg-10 bg-success d-flex py-1 rounded border border-secondary"
                        >
                            <input
                                type="text"
                                className="col-11 fs-5 border-0 bg-success text-white search-input ps-3"
                                placeholder="Write or Select"
                                onChange={(e)=>{setTitle(e.target.value)}}
                                value={title}
                            />
                        </div>
                    </div>

                    <div className='w-100 d-flex flex-column justify-content-center align-items-center mt-5'>
                        <div className = "text-secondary fs-8 pb-3 fw-bold">ADD ICON</div>
                    {
                            imageFile && imageFile.name ? 
                            <>
                                <img src = {imageURL} alt = ""
                                    style = {{width:"50px"}}
                                />
                                <div className = " d-flex justify-content-between align-items-center mt-3">
                                    <div className = "text-info text-decoration-underline text-wrap overflow-hidden">{imageFile.name}</div>
                                    <input 
                                        id = "reimage-input"
                                        type="file" 
                                        name="imageFile"
                                        accept='image/jpeg, image/png, image/jpg, image/svg+xml'
                                        onChange={handleImage}
                                        style={{display:"none"}}
                                        />
                                        <label for="reimage-input">
                                            <div 
                                                className = "text-info py-2 px-3 ms-2 bg-success rounded"
                                                role='button'
                                            >Change</div>
                                        </label>
                                </div>
                            </>
                            : 
                            <div className = " d-flex bg-secondary justify-content-center">
                                <input 
                                    id = "image-input"
                                    type="file" 
                                    name="imageFile"
                                    accept='image/jpeg, image/png, image/jpg'
                                    onChange={handleImage}
                                    style={{display:"none"}}
                                    />
                                <label for="image-input">
                                    <img src = {Attach} alt = "" role="button"/>
                                </label>
                            </div>
                        }
                    </div>
                    <div className = 'w-100 pt-5 d-flex justify-content-center'>
                        <div className = "text-white px-5 py-2 bg-secondary rounded-pill"
                            role = 'button'
                            onClick={()=>saveHandler()}
                        >Save</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddCategory;